/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import type ForgeAdminPageType from '@jira/spa-apps__forge-admin/src/ForgeAdminPageShellWithAnalytics.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyForgeAdminPage: LazyComponent<React.ComponentType<Record<any, any>>> =
	lazyForPaint<typeof ForgeAdminPageType>(
		() =>
			import(
				/* webpackChunkName: "async-forge-spa-admin", jiraSpaEntry: "async-forge-spa-admin" */ '@jira/spa-apps__forge-admin/src/ForgeAdminPageShellWithAnalytics.tsx'
			),
	);

export const ForgeAdminPage = (): React.JSX.Element => (
	<LazyPage Page={LazyForgeAdminPage} pageId="forge-spa-admin" shouldShowSpinner />
);

export default ForgeAdminPage;
